import { FC, useEffect, useRef } from 'react';
import { observer } from 'mobx-react-lite';

import { VIEW_MODES } from 'consts/viewModes';
import { store } from 'store';

import * as S from './ViewSelector.styles';

export const ViewSelector: FC = observer(() => {
  const {
    currentViewMode: activeView,
    setViewMode,
    isViewSelectorOpen,
    closeViewSelector,
    toggleViewSelector,
    mindAvailable,
  } = store.galaxyStore;
  // AI Mind appears only once the API ships behavioral coordinates
  const options = VIEW_MODES.filter((o) => o.value !== 'mind' || mindAvailable);
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (containerRef.current && !containerRef.current.contains(event.target as Node)) {
        closeViewSelector();
      }
    };

    if (isViewSelectorOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isViewSelectorOpen, closeViewSelector]);

  const handleSelectView = (value: string) => {
    if (value !== activeView) {
      setViewMode(value as any);
      closeViewSelector();
    }
  };

  return (
    <S.Container ref={containerRef}>
      <S.Button onClick={toggleViewSelector}>Galaxy View</S.Button>
      <S.Dropdown $isOpen={isViewSelectorOpen}>
        {options.map((option) => (
          <S.Option
            key={option.value}
            onClick={() => handleSelectView(option.value)}
            $isActive={option.value === activeView}
          >
            <S.OptionIcon>{option.icon}</S.OptionIcon>
            {option.label}
          </S.Option>
        ))}
      </S.Dropdown>
    </S.Container>
  );
});
